import React from 'react';
import PropTypes from 'prop-types';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';

const AccountPickerMessage = ({ message }) => (
	<div data-test-id="account-picker-favourites-message" className="account-picker__favouritesMessage">
		<HighlightTile type="info">{message}</HighlightTile>
	</div>
);

AccountPickerMessage.propTypes = {
	message: PropTypes.string.isRequired,
};

export default AccountPickerMessage;
